module.exports = __webpack_public_path__ + "img/Kosovo.8d2f1cff.svg";